import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { SmsService } from "../../../modulos/general/componentes/gestion-terceros/servicios/sms.service";
import { ModalPhoneComponent } from "./modal-phone.component";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule
    ],
    declarations: [
        ModalPhoneComponent
    ],
    exports: [
        ModalPhoneComponent
    ],
    providers: [
        SmsService
    ]
})
export class ModalPhoneModule { }
